import { TABLE_BILLS_MUTATIONS } from '@/state/mutation-types'

export default {
  state: {
    hiresWithRecentBillReminders: [],
    defaultBillReminderText: '',
  },
  mutations: {
    [TABLE_BILLS_MUTATIONS.ADD_HIRES_WITH_RECENT_BILL_REMINDER](state, hireIds) {
      // eslint-disable-next-line no-param-reassign
      state.hiresWithRecentBillReminders = [
        ...new Set([...state.hiresWithRecentBillReminders, ...hireIds]),
      ]
    },
    [TABLE_BILLS_MUTATIONS.SET_DEFAULT_BILL_REMINDER_TEXT](state, text) {
      // eslint-disable-next-line no-param-reassign
      state.defaultBillReminderText = text
    },
  },
}
